// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__aEOSe","icon":"Tag_icon___8M55","content":"Tag_content___0q3g"};